import {processAPIResponse} from "@/utils/request";
import {fetchSalesInfluencersList} from "@/services/api/salesInfluencer";
import {SalesInfluencerModel} from "@/typings/models/SalesInfluencer";

const initialState: { list: SalesInfluencerModel[], initialized: boolean } = {
  list: [],
  initialized: false,
}

export default {
  namespace: 'salesInfluencers',

  state: initialState,

  effects: {
    * fetchSalesInfluencers(_, {call, put}) {
      const {response, data} = yield call(fetchSalesInfluencersList);
      yield processAPIResponse({response, data}, {
        * onSuccess(list) {
          yield put({
            type: 'saveSalesInfluencers',
            payload: list || [],
          })
        }
      }, 'data')
    },
  },

  reducers: {
    saveSalesInfluencers(state, action) {
      return {
        ...state,
        list: action.payload,
        initialized: true,
      };
    },
    reset() {
      return initialState
    }
  }
};
